"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_container_1 = __importDefault(require("../../../container"));
var point_1 = require("../../stores/point");
var Point_1 = __importDefault(require("../../services/Point"));
var global_1 = require("../../stores/global");
var toggleCaching_1 = __importDefault(require("../caching/toggleCaching"));
var checkAutoPlay_1 = __importDefault(require("../playback/checkAutoPlay"));
var goToSleepMode_1 = __importDefault(require("../playback/goToSleepMode"));
var checkIsEnabledState_1 = __importDefault(require("./checkIsEnabledState"));
var setAmplifyOptions_1 = __importDefault(require("../playback/setAmplifyOptions"));
var setVolume_1 = __importDefault(require("../playback/setVolume"));
var point_2 = require("../../selectors/point");
var global_2 = require("../../selectors/global");
var setPlayState_1 = __importDefault(require("../playback/setPlayState"));
var _kernel_store_types_1 = require("../../types");
var playlist_1 = require("../../stores/playlist");
var generation_1 = require("../../stores/generation");
var mediafilesMeta_1 = require("../../stores/mediafilesMeta");
var generation_2 = require("../../selectors/generation");
var checkDisableControls_1 = __importDefault(require("../playback/checkDisableControls"));
var clearPoint = function (dispatch, persist, settings) { return __awaiter(void 0, void 0, void 0, function () {
    var leaveBackgroundOnClear;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                leaveBackgroundOnClear = settings.getSetting("LEAVE_BACKGROUND_ON_CLEAR", false);
                dispatch((0, setPlayState_1.default)(_kernel_store_types_1.EPlayState.STOP));
                dispatch((0, point_1.clearPointData)());
                dispatch((0, playlist_1.clearPlaylist)());
                dispatch((0, generation_1.clearGenerationSettings)());
                dispatch((0, mediafilesMeta_1.setMediafileDownloadQueue)([]));
                dispatch((0, toggleCaching_1.default)(leaveBackgroundOnClear));
                dispatch((0, global_1.resetAutoplayTrigger)());
                return [4, persist.clearState()];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
function fetchPoint() {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, settings, persist, update, data, state, prevPointId, prevStreamId, prevVolumeState, prevDisableControls, options, requiredVersion, fetchedPointInfo, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/fetchPoint");
                    settings = _kernel_container_1.default.get("SETTINGS");
                    persist = _kernel_container_1.default.get("PERSISTENCE");
                    update = _kernel_container_1.default.get("UPDATE");
                    dispatch((0, point_1.setPointMetadata)({
                        isFetching: true,
                        lastFetch: Date.now(),
                    }));
                    logger.debug("Fetch point started");
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 7, 8, 9]);
                    return [4, Point_1.default.getDeviceData()];
                case 2:
                    data = _c.sent();
                    state = getState();
                    logger.info("Received point data", { data: data });
                    prevPointId = (0, point_2.selectCurrentPointId)(state);
                    prevStreamId = (0, generation_2.selectCurrentStreamId)(state);
                    logger.info("Current stream id", { prevStreamId: prevStreamId });
                    prevVolumeState = (0, point_2.selectPointVolume)(state);
                    prevDisableControls = (0, global_2.selectHasDisableControlsAdditionalFeature)(state);
                    options = Point_1.default.getDeviceOptions(data);
                    if (!(options.bindingCode && options.bindingCode !== (0, global_2.selectBindingCode)(state))) return [3, 4];
                    return [4, settings.writeBindingCode(options.bindingCode)];
                case 3:
                    _c.sent();
                    dispatch((0, global_1.updateBindingCode)(options.bindingCode));
                    _c.label = 4;
                case 4: return [4, settings.setDebugMode(options.debugMode)];
                case 5:
                    _c.sent();
                    return [4, settings.setLogLevel(options.logLevel)];
                case 6:
                    _c.sent();
                    if (!!prevPointId && prevPointId !== options.pointId) {
                        logger.warn("Device point has changed, clearing state", {
                            prevPointId: prevPointId,
                            fetchedPointId: options.pointId,
                        });
                        clearPoint(dispatch, persist, settings);
                        return [2];
                    }
                    requiredVersion = data.device.requiredVersion;
                    update.checkUpdate(requiredVersion);
                    fetchedPointInfo = Point_1.default.getPointData(data);
                    dispatch((0, point_1.updatePointInformation)(fetchedPointInfo));
                    if (prevStreamId && !(0, point_2.selectPointStreamId)(getState())) {
                        logger.warn("Stream has been deleted, stopping playback", {
                            prevStreamId: prevStreamId,
                            currentStreamId: (0, point_2.selectPointStreamId)(getState()),
                        });
                        dispatch((0, setPlayState_1.default)(_kernel_store_types_1.EPlayState.STOP));
                        dispatch((0, playlist_1.clearPlaylist)());
                        dispatch((0, generation_1.clearGenerationSettings)());
                        dispatch((0, mediafilesMeta_1.setMediafileDownloadQueue)([]));
                        dispatch((0, global_1.resetAutoplayTrigger)());
                    }
                    if (data.device.additionalFeatures) {
                        dispatch((0, global_1.setAdditionalFeatures)(data.device.additionalFeatures));
                    }
                    if (fetchedPointInfo) {
                        if (!prevPointId ||
                            prevDisableControls !== (0, global_2.selectHasDisableControlsAdditionalFeature)(getState())) {
                            dispatch((0, checkDisableControls_1.default)());
                        }
                        logger.debug("Autoplay now", { autoplay: getState().global.autoPlay });
                        dispatch((0, checkAutoPlay_1.default)());
                        dispatch((0, goToSleepMode_1.default)());
                        dispatch((0, checkIsEnabledState_1.default)());
                        dispatch((0, setAmplifyOptions_1.default)({
                            promo: (_a = fetchedPointInfo.amplify.promo) !== null && _a !== void 0 ? _a : 1,
                            mediafile: (_b = fetchedPointInfo.amplify.mediafile) !== null && _b !== void 0 ? _b : 1,
                        }));
                        if (fetchedPointInfo.volume !== prevVolumeState) {
                            logger.debug("Updating volume from pointInfo", {
                                prevVolume: prevVolumeState,
                                currentVolume: fetchedPointInfo.volume,
                            });
                            dispatch((0, setVolume_1.default)(fetchedPointInfo.volume / 100));
                        }
                        logger.debug("Point updated", {
                            pointId: fetchedPointInfo.id,
                            userId: fetchedPointInfo.userId,
                        });
                    }
                    return [3, 9];
                case 7:
                    err_1 = _c.sent();
                    if (/Unauthorized/.test(err_1 === null || err_1 === void 0 ? void 0 : err_1.message)) {
                        logger.warn("Point data is null, stopping playback");
                        clearPoint(dispatch, persist, settings);
                    }
                    logger.error("Cannot fetch point", { err: err_1.toString() });
                    return [3, 9];
                case 8:
                    logger.debug("Done fetching point");
                    dispatch((0, point_1.setPointMetadata)({
                        isFetching: false,
                        isFetched: true,
                    }));
                    return [7];
                case 9: return [2];
            }
        });
    }); };
    action.type = "fetchPoint";
    return action;
}
exports.default = fetchPoint;
//# sourceMappingURL=fetchPoint.js.map